/* Keep the original file in Shopify's native multipart cart submission. */
if (!customElements.get('mugshot-creator')) {
  customElements.define('mugshot-creator', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.form = this.querySelector('form');
      this.panels = Object.fromEntries([...this.querySelectorAll('[data-step]')].map(p => [p.dataset.step, p]));
      this.choices = [...this.querySelectorAll('[data-format]')];
      this.photo = this.querySelector('[data-photo-input]');
      this.petName = this.querySelector('[data-pet-name]');
      this.crime = this.querySelector('[data-crime-input]');
      this.dob = this.querySelector('[data-dob]');
      this.error = this.querySelector('[data-error]');
      this.addButton = this.querySelector('[data-add-button]');
      this.photoTask = Promise.resolve(false);
      this.submitting = false;
      this.form.hidden = false;
      this.show('choose', false);
      this.choices.forEach(choice => choice.addEventListener('click', () => this.choose(choice.dataset.format)));
      this.querySelector('[data-change-format]').addEventListener('click', () => this.show('choose'));
      this.querySelector('[data-back-button]').addEventListener('click', () => this.show('details'));
      this.photo.addEventListener('change', () => { this.photoTask = this.checkPhoto(); });
      [this.petName, this.crime, this.dob].forEach(input => input.addEventListener('input', () => {
        input.setCustomValidity(''); this.reviewed = null; this.error.hidden = true;
      }));
      this.crime.addEventListener('input', () => this.updateCount());
      this.querySelectorAll('[data-crime]').forEach(button => button.addEventListener('click', () => {
        this.crime.value = button.dataset.crime;
        this.crime.dispatchEvent(new Event('input', { bubbles: true }));
        this.crime.focus();
      }));
      this.querySelector('[data-review-button]').addEventListener('click', () => this.review());
      this.form.addEventListener('submit', event => { event.preventDefault(); this.submitOrder(); });
      this.form.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target.matches('input:not([type=file])')) {
          event.preventDefault();
          if (this.step === 'details') this.review();
        }
      });
      window.addEventListener('pageshow', () => {
        this.submitting = false; this.addButton.disabled = false;
        this.form.removeAttribute('aria-busy');
        this.querySelector('[data-submit-status]').textContent = '';
      });
      const requested = this.dataset.initialFormat || new URLSearchParams(location.search).get('format');
      if (requested) this.choose(requested, false);
      this.updateCount();
      if (this.photo.files[0]) this.photoTask = this.checkPhoto();
    }
    show(step, focus = true) {
      this.step = step;
      Object.entries(this.panels).forEach(([name, panel]) => { panel.hidden = name !== step; });
      const index = ['choose', 'details', 'review'].indexOf(step);
      this.querySelectorAll('[data-progress]').forEach((item, i) => {
        item.classList.toggle('is-active', i <= index);
        if (i === index) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
      this.error.hidden = true;
      if (focus) this.panels[step].querySelector('legend').focus();
    }
    choose(format, focus = true) {
      const choice = this.choices.find(button => button.dataset.format === format);
      if (!choice || choice.disabled || !choice.dataset.variant) return;
      this.selected = choice; this.reviewed = null;
      this.querySelector('[data-variant-id]').value = choice.dataset.variant;
      this.querySelector('[data-product-type]').value = choice.dataset.title;
      this.choices.forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
      this.querySelector('[data-selected-product]').textContent = choice.dataset.title;
      this.querySelector('[data-selected-price]').textContent = `${choice.dataset.price} · Free UK delivery`;
      this.show('details', focus);
    }
    updateCount() { this.querySelector('[data-crime-count]').textContent = `${this.crime.value.length}/45`; }
    async checkPhoto() {
      const file = this.photo.files[0];
      this.checkedFile = null; this.reviewed = null; this.photo.setCustomValidity('');
      const status = this.querySelector('[data-file-status]');
      const preview = this.querySelector('[data-photo-preview]');
      preview.hidden = true; preview.removeAttribute('src');
      if (this.previewURL) URL.revokeObjectURL(this.previewURL);
      this.previewURL = null;
      if (!file) { status.textContent = ''; return false; }
      status.textContent = 'Checking your photo…';
      let url;
      try {
        if (!file.size) throw new Error('This file is empty. Please choose another photo.');
        if (file.size > 20 * 1024 * 1024) throw new Error('Please choose a photo smaller than 20 MB.');
        const bytes = new Uint8Array(await file.slice(0, 12).arrayBuffer());
        const jpeg = bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff;
        const png = [137, 80, 78, 71, 13, 10, 26, 10].every((byte, i) => bytes[i] === byte);
        if (!jpeg && !png) throw new Error('Please choose a JPG or PNG photo.');
        url = URL.createObjectURL(file);
        const image = new Image();
        await new Promise((resolve, reject) => {
          const timer = setTimeout(() => reject(new Error('This photo could not be read. Please try another JPG or PNG.')), 15000);
          image.onload = () => { clearTimeout(timer); image.naturalWidth && image.naturalHeight ? resolve() : reject(new Error('Please choose a readable photo.')); };
          image.onerror = () => { clearTimeout(timer); reject(new Error('This photo could not be read. Please try another JPG or PNG.')); };
          image.src = url;
        });
        if (this.photo.files[0] !== file) { URL.revokeObjectURL(url); return false; }
        this.checkedFile = file; this.previewURL = url; this.photo.setCustomValidity('');
        preview.src = url; preview.hidden = false;
        status.textContent = `Photo selected: ${file.name}`;
        return true;
      } catch (error) {
        if (url) URL.revokeObjectURL(url);
        if (this.photo.files[0] === file) { this.photo.setCustomValidity(error.message); status.textContent = error.message; }
        return false;
      }
    }
    async validate() {
      if (!this.selected || this.selected.disabled) { this.show('choose'); return false; }
      if (this.photo.files[0] && this.checkedFile !== this.photo.files[0]) {
        let pending;
        do { pending = this.photoTask; await pending; } while (pending !== this.photoTask);
      }
      this.petName.value = this.petName.value.trim(); this.crime.value = this.crime.value.trim();
      this.updateCount();
      this.petName.setCustomValidity(!this.petName.value ? 'Please add your pet’s name.' : this.petName.value.length > 30 ? 'Please keep the name to 30 characters.' : '');
      this.crime.setCustomValidity(!this.crime.value ? 'Please add their crime.' : this.crime.value.length > 45 ? 'Please keep the crime to 45 characters.' : '');
      if (!this.photo.files[0]) this.photo.setCustomValidity('Please choose your pet’s photo.');
      else if (this.checkedFile !== this.photo.files[0] && !this.photo.validationMessage) this.photo.setCustomValidity('Please select a readable JPG or PNG photo.');
      const invalid = [this.photo, this.petName, this.dob, this.crime].find(input => !input.checkValidity());
      if (invalid) {
        this.show('details', false); this.error.textContent = invalid.validationMessage;
        this.error.hidden = false; invalid.focus(); invalid.reportValidity(); return false;
      }
      return true;
    }
    signature() { return JSON.stringify([this.selected?.dataset.variant, this.petName.value, this.crime.value, this.dob.value]); }
    async review() {
      if (this.busy || this.submitting) return;
      this.busy = true;
      try {
        if (!await this.validate()) return;
        const values = { product: this.selected.dataset.title, price: this.selected.dataset.price,
          name: this.petName.value, crime: this.crime.value,
          dob: this.dob.value ? this.dob.value.split('-').reverse().join('/') : 'Not supplied', photo: this.checkedFile.name };
        Object.entries(values).forEach(([key, value]) => { this.querySelector(`[data-review-${key}]`).textContent = value; });
        this.reviewed = this.signature(); this.reviewedFile = this.checkedFile; this.show('review');
      } finally { this.busy = false; }
    }
    async submitOrder() {
      if (this.busy || this.submitting) return;
      if (this.step !== 'review' || this.reviewed !== this.signature() || this.reviewedFile !== this.photo.files[0]) { await this.review(); return; }
      this.busy = true;
      try {
        if (!await this.validate()) return;
        this.querySelector('[data-variant-id]').value = this.selected.dataset.variant;
        this.querySelector('[data-product-type]').value = this.selected.dataset.title;
        this.submitting = true; this.addButton.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        this.querySelector('[data-submit-status]').textContent = 'Uploading your photo and adding your MUGSHOT…';
        HTMLFormElement.prototype.submit.call(this.form);
      } finally { this.busy = false; }
    }
  });
}
